// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__P+uiv","popup__title":"errorPopup_popup__title__C4zdA","popup__img":"errorPopup_popup__img__Nlgm4","popup__nextBtn":"errorPopup_popup__nextBtn__p50Vx"};